import {useState} from "react";

export default function useContextCalendar(currentViewCalendar: "timeGridWeek" | "dayGridMonth" | "timeGridDay") {
    const [contextMenu, setContextMenu] = useState({
        visible: false,
        x: 0,
        y: 0,
        event: null,
    });
    const resetContext = () => {
        setContextMenu({
            visible: false,
            x: 0,
            y: 0,
            event: null,
        })
    }
    const handleContextMenu = (event: any, calendarEvent: any) => {
        event.preventDefault(); // Evita il menu contestuale del browser
        const calendarContainer = document.querySelector('.fc-scroller.fc-scroller-liquid-absolute');
        debugger
        (!currentViewCalendar || currentViewCalendar === 'timeGridWeek') && setContextMenu({
            visible: true,
            x: event.clientX > 1000 ? event.clientX-100 : event.clientX,
            y: event.clientY + (calendarContainer?.scrollTop || 0) - 50,
            event: calendarEvent,
        });
    };
    return {
        contextMenu,
        setContextMenu,
        handleContextMenu,
        resetContext
    };
}
